import React from 'react';
import { Form, Col } from 'react-bootstrap';
import PropTypes from 'prop-types';
import { HasPermission } from '../HasPermission';
// import { validateInput } from '../../utility/Validators';


const TextAreaField = ({ id, label, permission, md, sm, lg, xs, xl, rows, type, col, opts, placeholder, required, name, value, handleEvent, validators }) => {

    const errorMessage = 'Please fill the ' + label;
    const handleChange = (e) => {
        e.preventDefault();
        const { name, value } = e.target;
        const data = { name, value };
        handleEvent(data);
    }

    return (
        <>
            <Col md={md} sm={sm} lg={lg} xs={xs} xl={xl}>
                <HasPermission permission={permission}>
                    <Form.Group controlId={id}>
                        {label ? <Form.Label>{label}</Form.Label> : ''}
                        <Form.Control as={type} size={col} rows={rows} onChange={(e) => handleChange(e)} {...opts} name={name} value={value} placeholder={placeholder} />
                        <Form.Control.Feedback type="invalid">{errorMessage}</Form.Control.Feedback>
                    </Form.Group>
                </HasPermission>
            </Col>
        </>
    )
}

TextAreaField.propTypes = {
    id: PropTypes.string,
    value: PropTypes.string,
    name: PropTypes.string,
    placeholder: PropTypes.string,
    label: PropTypes.string,
    col: PropTypes.string,
    opts: PropTypes.any,
    permission: PropTypes.any,
    md: PropTypes.number,
    sm: PropTypes.number,
    lg: PropTypes.number,
    xs: PropTypes.number,
    xl: PropTypes.number,
    handleEvent: PropTypes.func.isRequired
};

TextAreaField.defaultProps = {
    id: '',
    value: '',
    name: '',
    col: 'md',
    permission: '',
    md: 12,
    sm: 12,
    lg: 12,
    xs: 12,
    xl: 12,
    placeholder: '',
    type: 'textarea',
    label: '',
    opts: {},
};
export default TextAreaField;